<template>
  <div id="listWidget" class="mb-5">
    <ul class="breadcrumb">
      <li v-if="zone" class="breadcrumb-item">{{ zone?.name }}</li>
      <li class="breadcrumb-item active">{{ pageTitle }}</li>
    </ul>
    <!-- 연결된 컨트롤러 정보 카드 -->
    <ControllerCard
      :controller="connectedController"
      controller-type="가상스위치 제어기"
      mode="setting"
      @close="connectedController._id = ''"
    />

    <div class="row">
      <VirtualControllerItem
        v-for="(item, index) in lightControllers"
        :key="item._id"
        :index="index"
        :data="item"
        v-on:onDeleteClick="onReceivedDeleteClick"
      />
    </div>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  
} from 'vue';
import { useStore } from 'vuex';
import Axios, { ZoneApi, CtrlApi } from '@/api';
import { useRouter, useRoute ,onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import VirtualControllerItem from './components/VirtualControllerItem.vue';
import ControllerCard from './components/ControllerCard.vue';

const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;
const route = useRoute();
const store = useStore();

const pageTitle = computed(() => 
  route.path.includes('regist-controllers') 
    ? '가상스위치 제어기 등록' 
    : '가상스위치 제어기 설정'
);

const zone = ref(undefined);
const VIRTUAL_SWITCH_MODEL = 'M91';
const lightControllers = ref([]);

const connectedController = ref({
  _id: '',
  version: '',
  model: '',
});

const targetController = ref(null); // 화면 진입 시 대상 컨트롤러(존에 이미 등록된 컨트롤러)

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'가상스위치 제어기 관리',isShowMenu:false,isShowZone:false,isShowProfile:false});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
})
onMounted(() => {
  requestZone();
  console.log('ControllerSettingPage.onMounted => zone : ', zone.value);
});

const requestDeleteController = async (payload) => {
  try {
    console.log(
      'ControllerSettingPage.onReceivedDeleteClick() => payload : ' +
        JSON.stringify(payload),
    );
    const result = await Axios.delete(
      CtrlApi.DELETE_CTRL.replace(':id', payload.id),
    );
    if (result.resultCode === '0000') {
      requestZone();
      store.commit('home/deleteController', {
        zoneId: route.params.zoneId,
        controllerId: payload.id,
      });
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    console.log(error)
    emitter.emit('showPopAlert', {
      description: '가상스위치 제어기 삭제에 실패했습니다.',
    });
  }
};

const requestZone = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.get(
        ZoneApi.ZONE_INFO.replace(':id', route.params.zoneId),
      );
      if (result.resultCode === '0000') {
        zone.value = result.resultData;
        // zone.controllers에는 기본 컨트롤러 정보만 있으므로 /controllers로 enrich 해서
        // 버튼(BLE/WiFi) 표시에 필요한 product/firmware 정보를 확보한다.
        try {
          const ctrlRes = await Axios.get(CtrlApi.CONTROLLERS, {});
          if (ctrlRes?.resultCode === '0000' && Array.isArray(ctrlRes.resultData)) {
            const byId = {};
            ctrlRes.resultData.forEach((c) => {
              if (c?._id) byId[c._id] = c;
            });
            if (Array.isArray(zone.value.controllers)) {
              zone.value.controllers = zone.value.controllers.map((c) => byId[c?._id] || c);
            }
          }
        } catch (e) {
          console.warn('requestZone controller enrich failed:', e);
        }

        lightControllers.value = zone.value.controllers.filter(controller => controller?.model === VIRTUAL_SWITCH_MODEL && controller?._id?.split("_")?.length >= 2)
        // 이 화면은 zoneId로 진입하므로, 기본적으로 첫 번째(혹은 단일) 컨트롤러를 대상 컨트롤러로 잡는다.
        targetController.value = lightControllers.value?.length > 0 ? lightControllers.value[0] : null;
        resolve(result);
      } else {
        // emitter.emit('showPopAlert', {
        //   description: result.resultMessage,
        // });
        reject(result.resultMessage);
      }
    } catch (error) {
      // emitter.emit('showPopAlert', {
      //   description: '영역 조회에 실패했습니다.',
      // });
      reject("영역 조회에 실패했습니다.");
    }
  });
};

const onReceivedDeleteClick = async (payload) => {
  // let deviceCount = 0;
  // zone.value.groups.forEach((item) => {
  //   deviceCount = deviceCount + item.devices.filter(d => d.controllerId == payload.id).length;
  // });

  // if (deviceCount > 0) {
  //   emitter.emit('showPopAlert', {
  //     description: '단말정보가 포함된 가상스위치 제어기는 삭제할 수 없습니다.',
  //   });
  //   return;
  // }

  emitter.emit('showPopConfirm', {
    description: '관련된 장치 등의 모든 데이터가 삭제됩니다.\n가상스위치 제어기를 삭제하시겠습니까?',
    okCallback: () => requestDeleteController(payload)
  });  
};
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #495057;
}

.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  color: #856404;
  font-size: 0.8rem;
}

.warning-box i {
  color: #ffc107;
  flex-shrink: 0;
  margin-top: 0.1rem;
  font-size: 0.85rem;
}

.action-button-container {
  margin-top: 0;
}

.action-button-container .btn {
  padding: 0.625rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.action-button-container .btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
</style>
